import $ from "jquery";
import "slick-carousel";

const sliderHero = () => {
  const el = {
    container: ".HeroSection",
    sliderEl: ".HeroSection .js-HeroSlider",
    image: ".HeroSection .js-HeroSlider img",
    button: ".HeroSection .js-ButtonSlider",
    text: ".HeroSection .HeroSection__Contents__Headline__Item",
  };

  if ($(el.container).length === 0) return;
  $('#text-variant-1').addClass('active')

  $(el.sliderEl).slick({
    dots: false,
    prevArrow: false,
    nextArrow: false,
    // autoplay: true,
    // autoplaySpeed: 2000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // variableWidth: true,
  });

  $(document).on('click', el.button, function () {
    // change button active
    $(el.button).removeClass('active')
    $(this).toggleClass('active')


    // change image slider
    const id = $(this).attr('id')
    const arrIdTarget = id.split('-');
    $(el.sliderEl).slick('slickGoTo', parseInt(arrIdTarget[2]) - 1);

    // change text active
    $(el.text).removeClass('active')
    $(`#text-${arrIdTarget[1]}-${arrIdTarget[2]}`).toggleClass('active')


    // reload animation
    $('.HeroSection__Contents__Headline__Item .js-loaded-animation').removeClass('loaded')
    $('.HeroSection__Contents__Headline__Item .js-loaded-animation').each(function () {
      const delay = $(this).data("delay");
      if (delay) {
        setTimeout(() => {
          $(this).addClass("loaded");
        }, delay);
      } else {
        $(this).addClass("loaded");
      }
    });


  })



};

try {
  sliderHero();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
